import { createI18n } from 'vue-i18n'
import zhLocale from './zh-CN'
import twLocale from './zh-TW'
import store from '@/store'
const messages = {
  'zh-TW': {
   msg: {
     ...twLocale
   }
  },
  'zh-CN': {
   msg: {
     ...zhLocale
   }
  }
 }

function getLanguage () {
  return window.localStorage.getItem('language') || store.state.user.language
}
const i18n = createI18n({
  // 使用 composition Api
  legacy: true,
  // 全局使用 t函数
  // globalInjection: true,
  locale: getLanguage() || 'zh-CN',
  messages
})

export default i18n
